const notFound = {
  title: "404",
  message: "Упс! Страницата не е намерена",
  backHome: "Към началото",
};

export default notFound;

